import { SanityClient } from '@sanity/client'

import { allEmployeeInfoGroq, EmployeeCategoriesGroq } from '~/shared/queries/employee'

import { Employee, EmployeeCategory } from '~/employee/types/employee.types'
import sanityClient from '~/shared/sanity/sanity-client'
import { AppLanguage } from '~/types/locale'

class EmployeeSanity {
  private client: SanityClient

  public constructor() {
    this.client = sanityClient
  }

  public getAllEmployeeData({ language }: { language: AppLanguage }): Promise<Employee[] | null> {
    return this.client.fetch(allEmployeeInfoGroq, { language })
  }

  public getEmployeeCategories({ language }: { language: AppLanguage }): Promise<EmployeeCategory[] | null> {
    return this.client.fetch(EmployeeCategoriesGroq, { language })
  }
}

export const employeeSanity = new EmployeeSanity()
